import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ClerkProvider } from '@clerk/clerk-react';
import { PostHogProvider } from 'posthog-js/react';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import './index.css';
import { getPostHogProviderOptions } from './lib/posthog';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key');
}

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY as
  | string
  | undefined;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST as
  | string
  | undefined;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const app = (
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </QueryClientProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} afterSignOutUrl="/">
      {posthogKey && posthogHost ? (
        <PostHogProvider
          apiKey={posthogKey}
          options={getPostHogProviderOptions()}
        >
          {app}
        </PostHogProvider>
      ) : (
        app
      )}
    </ClerkProvider>
  </React.StrictMode>,
);


